"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _FormHelperText = _interopRequireDefault(require("./FormHelperText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A simple input to be used in a form.
 */
const FormInput = props => {
  const {
    feedbackType,
    helperText,
    id,
    inputType,
    isInvalid,
    isValid,
    labelText,
    placeholderText,
    ...restOfProps
  } = props;
  restOfProps.isInvalid = feedbackType && feedbackType === 'invalid' || isInvalid;
  restOfProps.isValid = feedbackType && feedbackType === 'valid' || isValid;
  restOfProps.placeholder = placeholderText;
  restOfProps.type = inputType;
  let feedbackDescription = `${id}-${feedbackType}`;
  return /*#__PURE__*/_react.default.createElement(_Form.default.Group, null, /*#__PURE__*/_react.default.createElement(_Form.default.Label, {
    htmlFor: id
  }, labelText), /*#__PURE__*/_react.default.createElement(_Form.default.Control, _extends({
    "aria-describedby": feedbackDescription,
    "aria-invalid": restOfProps.isInvalid,
    id: id
  }, restOfProps)), /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
    feedbackType: feedbackType,
    helperText: helperText,
    feedbackDescription: feedbackDescription
  }));
};
var _default = exports.default = FormInput;
FormInput.propTypes = {
  /**
   * The initial setting of the input's "value".
   */
  defaultValue: _propTypes.default.string,
  /**
   * Control the feedback text to appear as helper text, valid, or invalid feedback.
   */
  feedbackType: _propTypes.default.oneOf(['helper', 'valid', 'invalid']),
  /**
   * The helper text for an input.  Styles will change based on props.feedbackType.
   */
  helperText: _propTypes.default.string,
  /**
   * Size of the input
   */
  htmlSize: _propTypes.default.number,
  /**
   * The `ID` for the input & `htmlFor` the label
   */
  id: _propTypes.default.string.isRequired,
  /**
   * The input type
   */
  inputType: _propTypes.default.oneOf(['email', 'number', 'password', 'search', 'tel', 'text', 'textarea', 'url']),
  /**
   * The inputmode
   */
  inputMode: _propTypes.default.oneOf(['none', 'numeric', 'tel', 'decimal', 'email', 'url', 'search']),
  /**
   * Deprecated. Use `feedbackType` instead.
   */
  isInvalid: _propTypes.default.bool,
  /**
   * Deprecated. Use `feedbackType` instead.
   */
  isValid: _propTypes.default.bool,
  /**
   * The label text
   */
  labelText: _propTypes.default.string,
  /**
   * The onChange event callback
   */
  onChange: _propTypes.default.func,
  /**
   * The HTML5 validation pattern to set on the Form.Control.
   */
  pattern: _propTypes.default.string,
  /**
   * The placeholder text
   */
  placeholderText: _propTypes.default.string,
  /**
   * If the input is required
   */
  required: _propTypes.default.bool.isRequired,
  /**
   * The value of the underlying element.  Is controlled by onChange.  Initial prop is defaultValue
   */
  value: _propTypes.default.string
};

// FormInput Default properties
FormInput.defaultProps = {
  feedbackType: 'helper',
  required: false
};